
// This is an auto generated file - do not edit!
// Swagger path: /api/DocumentRequirementType/filtered

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    DocumentRequirementType, SystemEntity
} from '@wdx/clmi/clmi-swagger-gen';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class DocumentrequirementtypeFilteredApiService extends BaseApiService {
    
    get(entityType?: SystemEntity, clientId?: string, caseId?: string, activeOnly?: boolean, options = {}): Observable<DocumentRequirementType[]> {
        let params = new HttpParams();
        if(entityType !== undefined) {
            params = params.append('entityType', entityType);
        }
        if(clientId !== undefined) {
            params = params.append('clientId', clientId);
        }
        if(caseId !== undefined) {
            params = params.append('caseId', caseId);
        }
        if(activeOnly !== undefined) {
            params = params.append('activeOnly', activeOnly);
        }

        return this._get<DocumentRequirementType[]>(
            `/DocumentRequirementType/filtered`, {
                ...options,
                params,
            }
        );
    }
}
